( function( $ ) {

	$( document ).ready( function () {
		var itemsMainDiv = ( '.filters__carousel' );
		var itemsDiv = ( '.filters__carousel-inner' );
		var itemWidth = '';

		$( '.filters__left-arrow, .filters__right-arrow' ).click( function () {

			var condition = $( this ).hasClass( 'filters__left-arrow' );

			if ( condition )
				click( 0, this );
			else
				click( 1, this );
		} );

		ResCarouselSize();

		// Check if the currently active filter is visible.  If not, slide so that it is.
		var $activeFilterBtn = $( itemsDiv ).find( '.filters__btn.active' );
		if ( $activeFilterBtn.length ) {
			var $activeFilter = $activeFilterBtn.parent( '.filters__item' );
			if ( $activeFilter.length && !isElementVisible( $activeFilter[0] ) ) {
				var activeIndex = $( itemsDiv ).find( '.filters__item' ).index( $activeFilter );
				ResCarousel( 1, itemsMainDiv, activeIndex );
			}
		}

		// TODO: add passive flag to this event listener
		$( window ).resize( function () {
			ResCarouselSize();
		} );

		// This function defines the size of the items
		function ResCarouselSize() {
			var incno = 0;
			var dataItems = ( 'data-items' );
			var itemClass = ( '.filters__item' );
			var id = 0;
			var btnParentSb = '';
			var itemsSplit = '';
			var sampwidth = $( itemsMainDiv ).width();
			var bodyWidth = $( 'body' ).width();

			$( itemsDiv ).each( function () {
				id = id + 1;
				var itemNumbers = $( this ).find( itemClass ).length;
				btnParentSb = $( this ).parent().attr( dataItems );
				itemsSplit = btnParentSb.split( ',' );

				$( this ).parent().attr( 'id', 'landingPageFilters' + id );

				if ( bodyWidth >= 992 ) {
					incno = itemsSplit[3];
					itemWidth = sampwidth / incno;
				} else if ( bodyWidth >= 768 ) {
					incno = itemsSplit[2];
					itemWidth = sampwidth / incno;
				} else {
					incno = itemsSplit[1];
					itemWidth = sampwidth / incno;
				}

				$( this ).css( { 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers } );
				$( this ).find( itemClass ).each( function () {
					$( this ).outerWidth( itemWidth );
				} );

				$( '.filters__left-arrow' ).addClass( 'over' );
				$( '.filters__right-arrow' ).removeClass( 'over' );
			} );
		}

		// This function used to move the items
		function ResCarousel( e, el, s ) {
			var leftArrow = ( '.filters__left-arrow' );
			var righArrow = ( '.filters__right-arrow' );
			var translateXval = '';
			var divStyle = $( el + ' ' + itemsDiv ).css( 'transform' );
			var values = divStyle.match( /-?[\d.]+/g );
			var xds = Math.abs( values[4] );

			if ( e == 0 ) {
				translateXval = parseInt( xds ) - parseInt( itemWidth * s );
				$( el + ' ' + righArrow ).removeClass( 'over' );

				if ( translateXval <= itemWidth / 2 ) {
					translateXval = 0;
					$( el + ' ' + leftArrow ).addClass( 'over' );
				}
			}

			else if ( e == 1 ) {
				var itemsCondition = $( el ).find( itemsDiv ).width() - $( el ).width();

				translateXval = parseInt( xds ) + parseInt(itemWidth * s );

				$( el + ' ' + leftArrow ).removeClass( 'over' );

				if ( translateXval >= itemsCondition - itemWidth / 2 ) {
					translateXval = itemsCondition;
					$( el + ' ' + righArrow ).addClass( 'over' );
				}
			}
			$( el + ' ' + itemsDiv ).css( 'transform', 'translateX( ' + -translateXval + 'px)' );
		}

		// It is used to get some elements from btn
		function click( ell, ee ) {
			var Parent = '#' + $( ee ).parent().attr( 'id' );
			var slide = $( Parent ).attr( 'data-slide' );
			ResCarousel( ell, Parent, slide );
		}

		// Returns true/false for if the passed in element is visible
		function isElementVisible( el ) {
			var rect = el.getBoundingClientRect();
			var vWidth = window.innerWidth || document.documentElement.clientWidth;
			var vHeight = window.innerHeight || document.documentElement.clientHeight;
			var efp = function ( x, y ) {
				return document.elementFromPoint( x, y );
			};

			// Return false if it's not in the viewport
			if ( rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight ) {
				return false;
			}

			// Return true if the two top corners are visible
			return (
				el.contains( efp( rect.left,  rect.top ) )
				&& el.contains( efp( rect.right, rect.top ) )
			);
		}
	} );

} )( jQuery );
